export default __webpack_public_path__ + "static/media/O-021.d03d96c2.png";